const checkObjectIsNotEmpty = obj => Object.entries(obj).length !== 0

export default checkObjectIsNotEmpty